/* eslint-disable lines-around-directive,strict,react/sort-comp,react/no-string-refs,lines-between-class-members,prefer-template,jsx-a11y/no-static-element-interactions,react/destructuring-assignment,react/prop-types,dot-notation,react/no-danger */
'use strict';

import React from 'react';

import { SVG } from 'common-ui/src/components/module';
import Styles from './SpeedBumpModal.scss';
import AccessibilityUtils from '../utils/AccessibilityUtils';
import Constants from '../constants/Constants';

export default class SpeedBumpModal extends React.Component {
    componentDidMount() {
        AccessibilityUtils.handleFocusRestriction(
            this.refs.speedBumpPopup,
            Constants.TAB_ELEMENT_SLECETORS_FOR_POPUP,
            true,
        );
    }
    render() {
        return (
            <div className="modal-open">
                <div
                    className={
                        Styles['modal-vertical-centered'] + ' modal show in'
                    }
                    role="alert"
                    tabIndex="-1"
                    aria-describedby="speedbump"
                >
                    <div
                        className="modal-dialog"
                        id="speedbump"
                        onKeyDown={this.props.handlers.onEscKey}
                    >
                        <div
                            className={Styles['message'] + ' modal-content'}
                            ref="speedBumpPopup"
                        >
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className={Styles['close-btn'] + ' close'}
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={this.props.handlers.onCancelClick}
                                >
                                    <span aria-hidden="true">
                                        <SVG
                                            className={Styles['close-btn-icon']}
                                            name="Close"
                                            size="sm"
                                        />
                                    </span>
                                </button>
                                <h2 className="modal-title">
                                    {this.props.config.title}
                                </h2>
                            </div>

                            <div className="modal-body">
                                <div className="modal-body-content">
                                    {this.props.config.msg && (
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: this.props.config.msg,
                                            }}
                                        />
                                    )}
                                    {this.props.config.msgNode && <>{this.props.config.msgNode}</>}
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className={
                                        Styles['ok-button'] +
                                        ' btn lg btn-primary'
                                    }
                                    onClick={this.props.handlers.onOkClick}
                                    aria-label={this.props.config.labels.ok}
                                >
                                    {this.props.config.labels.ok}
                                </button>
                                <button
                                    type="button"
                                    className={
                                        Styles['cancel-button'] +
                                        ' btn lg btn-secondary'
                                    }
                                    onClick={this.props.handlers.onCancelClick}
                                    aria-label={this.props.config.labels.cancel}
                                >
                                    {this.props.config.labels.cancel}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" />
            </div>
        );
    }
}
